export default "__VITE_PUBLIC_ASSET__740c51f6__"